var React = require('react');

function BlackTaurus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.9078,11.0913c3.377-1.9791,5.6561-5.637,5.6561-9.8254h-3.6263c0,4.2818-3.483,7.7639-7.7639,7.7639S6.4089,5.5477,6.4089,1.2659h-3.6263c0,4.1893,2.2791,7.8473,5.6561,9.8254-2.0081,1.6572-3.29,4.163-3.29,6.9643,0,4.9762,4.0479,9.025,9.0249,9.025s9.025-4.0488,9.025-9.025c0-2.8013-1.2828-5.308-3.2908-6.9643ZM14.1736,23.4542c-2.9772,0-5.3986-2.4223-5.3986-5.3986s2.4214-5.3995,5.3986-5.3995,5.3987,2.4224,5.3987,5.3995-2.4224,5.3986-5.3987,5.3986Z","fill":"#ebc192","strokeWidth":"0"}));
}

BlackTaurus.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BlackTaurus;

BlackTaurus.default = BlackTaurus;
